import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'mg-icon',
  templateUrl: './icons.component.html',
  styleUrls: ['./icons.component.scss'],
})
export class IconsComponent implements OnInit {
  @Input() size!: string | number;
  @Input() hover: boolean = false;

  private regexUnits: RegExp =
    /(\d*\.?\d+)\s?(px|em|rem|ex|%|in|cn|mm|pt|pc+)/gim;
  private regexOnlyNumbers: RegExp = /^[0-9]*$/gim;

  public defaultSize = 20;

  constructor() {}

  ngOnInit(): void {}

  public styles() {
    if (!this.size) {
      return {
        fontSize: `${this.defaultSize}px`,
        width: `${this.defaultSize}px`,
        height: `${this.defaultSize}px`,
      };
    }

    if (
      typeof this.size === 'number' ||
      this.regexOnlyNumbers.test(this.size)
    ) {
      return { 'font-size': `${this.size}px` };
    }

    if (this.regexUnits.test(this.size)) {
      return { 'font-size': this.size };
    }

    return { 'font-size': `${this.defaultSize}px` };
  }
}
